import type { UseQueryResult } from "@tanstack/react-query";

import { useAndroidAppsData, useIosAppsData } from "app/pages/sales-intelligence/pages/find-apps/queries/useGetAppsData";
import type { IFindAppsResponseDto } from "app/pages/sales-intelligence/store/find-apps/types/dto";

function useTabsData(): readonly UseQueryResult<IFindAppsResponseDto, unknown>[] {
    const androidAppsQuery = useAndroidAppsData();
    const iosAppsQuery = useIosAppsData();

    return [androidAppsQuery, iosAppsQuery];
}

export default useTabsData;
